import SessionEvent from 'session/SessionEvent.js';
import Tone from 'tone';
import {SUB_SEQUENCE_VOLUME_CHANGE} from 'session/constants.js';

class SubSequenceVolumeChangeEvent extends SessionEvent {
    constructor(subSequence, volume) {
        super();
        this.subSequence = subSequence;
        this.volume = volume;
    }

    setValue(v) {
        this.volume = v;
    }

    getValue() {
        return this.volume;
    }

    isSkippable() {
        return false;
    }

    executeEvent(sequencerEngine, nextEvent) {
        if (nextEvent === undefined || this.subSequence === undefined ||
            this.subSequence.linearRampFade === undefined) {
            return;
        }
        let rampSteps = nextEvent.step - this.step;
        let rampTime =  rampSteps * new Tone.Time('32n').toMilliseconds() / 1000.0;
        this.subSequence.linearRampFade(Math.max(0, this.value), Math.max(0, nextEvent.volume), rampTime);
    }

    getType() {
        return SUB_SEQUENCE_VOLUME_CHANGE;
    }

    getCopy(sequencerEngine) {
        return new SubSequenceVolumeChangeEvent()
            .fromJson(this.getJson(), sequencerEngine);
    }

    getJson() {
        return {
            ... super.getJson(),
            subSequence: this.subSequence.id,
            volume: this.volume
        };
    }

    fromJson(json, sequencerEngine) {
        super.fromJson(json);
        this.subSequence = sequencerEngine.getSubSequence(json.subSequence);
        this.volume = json.volume;
        return this;
    }
}

export default SubSequenceVolumeChangeEvent;
